import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  microsoftAuthApiRef,
  oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import { GitlabAuth, MicrosoftAuth } from '@backstage/core-app-api';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import type { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

export const apisConfig: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: techRadarApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ({
      async load() {
        const url = configApi.getString('techRadar.url');
        const data = await fetch(url).then(res => res.json());
        return {
          ...data,
          entries: data.entries.map(
            (entry: TechRadarLoaderResponse['entries'][number]) => ({
              ...entry,
              timeline: entry.timeline
                .map(snapshot => ({
                  ...snapshot,
                  date: new Date(snapshot.date),
                }))
                .toSorted((a, b) => b.date.valueOf() - a.date.valueOf()),
            }),
          ),
        };
      },
    }),
  }),

  createApiFactory({
    api: gitlabAuthApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
    },
    factory: ({ configApi, discoveryApi, oauthRequestApi }) => {
      const environment =
        configApi.getOptionalString('auth.environment') ?? 'development';
      return GitlabAuth.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        environment,
        provider: {
          id: 'gitlab',
          title: 'GitLab',
          icon: () => null,
        },
      });
    },
  }),

  createApiFactory({
    api: microsoftAuthApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
    },
    factory: ({ configApi, discoveryApi, oauthRequestApi }) => {
      const environment =
        configApi.getOptionalString('auth.environment') ?? 'development';
      return MicrosoftAuth.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        environment,
      });
    },
  }),
];
